<template>
    <div class="all-wrapper grey-wrapper" id="app" v-show="isUserLoad"
         :class="{'no-stickers': true,
		 'page-auth': !isModerator || isNoSuccessSection || isUserContract || isNoRemovePageAccess,
		 'staff-page': (isStaffPage || isContactsPage),
		 '--contacts': isContactsPage,
		 'rule-edit': popups.addRule.show,
		 'admin-editable': (!(isStaffPage || isContactsPage) && tumblers.editable.value || (isStaffPage && tumblers.staffEditable.value || isContactsPage && tumblers.contactEditable.value)) && (user.access_rights.is_owner || isContactsPage && tumblers.contactEditable.value && user.is_can_contact_edit) && !popups.addRule.show,
		  'section-detail-page': isSectionDetail,
		  'users-scheme-page': isUsersScheme,
          '--search': isSearch,
		  'editor-editable': (!(isStaffPage || isContactsPage) && tumblers.editable.value || (isStaffPage && tumblers.staffEditable.value ||
			  isContactsPage && tumblers.contactEditable.value) ) && (curTopSection && (curTopSection.rights == 'W' || user.is_chef)) && !popups.addRule.show && !((isStaffPage || isContactsPage) && !user.access_rights.is_owner)}">
        <header v-if="(isModerator && !isNoSuccessSection) && !isUserContract && !isNoRemovePageAccess" :class="{'header-moderator --moderator': true,  '--auth': !isModerator, '--no-bottom-header': !isShowBottomHeader || isSearch}">
            <div class="header-main">
                <div class="inner-wrapper df df--space-between">
                    <div class="h-left" >
                        <header-logo ></header-logo>

						<div class="" v-if="!(isStaffPage || isContactsPage) && !isSectionDetail && !isUsersScheme" style="width: 297px; margin-left: 61px;">
							<rules-search :class="{isEditor: user.access_rights.is_owner}" v-if="!popups.addRule.show"></rules-search>
						</div>
                    </div>
					<top-sections v-if="isUserLoad && !isShowBottomHeader && !isSectionDetail && !isUsersScheme && topSections.length !== 1 && !(isStaffPage || isContactsPage)" class="top-sections"></top-sections>
					<div class="" v-if="!isSectionDetail && !isUsersScheme && !(isStaffPage || isContactsPage) && isShowBottomHeader">
						<div class="has-hint tumbler__editable" v-if="(user.access_rights.is_owner || (curTopSection && (curTopSection.rights == 'W' || user.is_chef)) ) && !popups.addRule.show">
                            <tumbler
                                :name="tumblers.editable.name"
                                :value="tumblers.editable.value"
                                :icon="'i i-pencil2'"
                            >
                            </tumbler>
							<span class="hint bottom-center-direction">Режим редактирования</span>
						</div>
					</div>

					<div class="" v-if="isUsersScheme">
						<div class="has-hint tumbler__editable">
                            <tumbler
                                :name="tumblers.schemeEditable.name"
                                :value="tumblers.schemeEditable.value"
                                :icon="'i i-pencil2'"
                            >
                            </tumbler>
							<span class="hint bottom-center-direction">Режим редактирования</span>
						</div>
					</div>

					<div class="" v-if="isStaffPage && !editorOpen">
						<div class="has-hint tumbler__editable" v-if="(user.access_rights.is_owner || user.is_can_dismiss && isStaffPage) && !popups.addRule.show">
							<tumbler
								:name="tumblers.staffEditable.name"
								:value="tumblers.staffEditable.value"
								:icon="'i i-pencil2'"
							>
							</tumbler>

							<span class="hint bottom-center-direction">Режим редактирования</span>
						</div>
					</div>
                    <div class="" v-if="isContactsPage">
						<div class="has-hint tumbler__editable" v-if="(user.access_rights.is_owner || user.is_can_contact_edit && isContactsPage) && !popups.addRule.show">
							<tumbler
								:name="tumblers.contactEditable.name"
								:value="tumblers.contactEditable.value"
								:icon="'i i-pencil2'"
							>
							</tumbler>

							<span class="hint bottom-center-direction">Режим редактирования</span>
						</div>
					</div>
                    <top-sections-staff v-if="isStaffPage" class="top-sections"></top-sections-staff>

                    <div class="h-right">
						<template v-if="!isSectionDetail">
                            <router-link v-if="(user.access_rights.is_owner || user.is_chef || user.access_rights.is_tech_writer ) && !popups.addRule.show" @click.native="resetSearch();" href="/rules/screencasts/" :to="'/screencasts/'" class="staff-link" :class="{'active': isScreencasts}">
                                <span class="i-wrapper">
									<span class="i i-monitor"></span>
                                </span>
                            </router-link>
							<router-link v-if="(user.access_rights.is_owner || user.is_can_user_scheme) && !popups.addRule.show" @click.native="resetSearch();" href="/rules/users-scheme/" :to="'/users-scheme/'" class="staff-link" :class="{'active': isUsersScheme}">
                                <span class="i-wrapper">
									<span class="i i-users-scheme"></span>
                                </span>
                            </router-link>
							<router-link v-if="(user.access_rights.is_owner || user.is_can_contact_edit) && !popups.addRule.show" @click.native="resetSearch();" href="/rules/contacts/" :to="'/contacts/'" class="staff-link" :class="{'active': isContactsPage}">
                                <span class="i-wrapper">
									<span class="i i-contacts"></span>
                                </span>
                            </router-link>
                            <router-link v-if="(user.access_rights.is_owner || user.is_can_dismiss && user.is_rules || user.is_can_contract && user.is_rules || user.is_can_user_scheme) && !popups.addRule.show" @click.native="resetSearch();" href="/rules/staff/" :to="'/staff/'" class="staff-link" :class="{'active': isStaffPage}">
                                <span class="i-wrapper">
                                    <span class="i i-users"></span>
                                </span>
                            </router-link>
    						<router-link v-if="!popups.addRule.show && (user.is_can_contact_edit || user.is_can_dismiss  && user.is_rules || user.is_can_contract && user.is_rules || user.access_rights.is_owner)" @click.native="resetSearch();" href="/" :to="'/'" class="staff-link"
                                :class="{'active': !isContactsPage && !isStaffPage && !isUsersScheme && !isScreencasts}">
                                <span class="i-wrapper">
                                    <span class="i i-hammer"></span>
                                </span>
                            </router-link>
                            <div>
                                <tooltip v-if="user.firstName"
                                         :direction="'bottom-right-direction'"
                                         :add-class-wrap="'h-user'"
                                         :add-class-btn="'l'"
                                         :btn-big="true"
                                         @tooltipShow="userTooltipActive = true"
                                         @tooltipClose="userTooltipActive = false"
                                         :add-class="'h-user-menu'">
                                    <span slot="tooltipBtn">
                                        <span class="t">
                                            {{ user.firstName.charAt(0) }}
                                        </span>
                                    </span>

                                    <div slot="tooltipContent">
                                        <div class="h-user-menu__item">
                                            <span class="t">{{ user.firstName }} {{ user.lastName }}</span>
                                        </div>

                                        <div class="h-user-menu__item">
                                            <span class="t">{{ user.phone }}</span>
                                        </div>

                                        <div class="h-user-menu__bottom">
                                            <button class="btn size-s btn--ico" @click="logout()">
                                                <span class="i i-exit2"></span>
                                                <span class="t">ВЫЙТИ</span>
                                            </button>
                                        </div>
                                    </div>
                                </tooltip>
                            </div>
						</template>
						<template v-else>
							<div class="saving-loader mr32" :class="{load: userSectRightLoader}">
								<div class="df saved">
									<span class="i i-saved mr8"></span>
									изменения сохранены
								</div>
								<div class="df loading">
									<div class="preloader-white"></div>
									изменения сохраняются
								</div>
							</div>
							<div class="close-section-detail" @click="closeSectionDetail" v-if="!userSectRightLoader">
								<span class="i i-cross"></span>
							</div>
						</template>

                    </div>
                </div>
                <!-- end inner-wrapper -->
            </div>

            <!-- end header__bottom -->
			<div class="header-moderator__bottom" v-if="isShowBottomHeader && !isSearch">
				<top-sections v-if="isUserLoad"></top-sections>
			</div>

        </header>


        <main id="main">
            <router-view v-if="(isModerator||isContractor) && !isNoSuccessSection && !isNoRemovePageAccess"/>

            <section v-else>
                <div class="content">

                    <router-link @click.native="setIsNoSuccessSection()" to="/" tag="div" style="cursor: pointer;" class="mt40 text-center" v-if="isNoSuccessSection">
                        <img :src="isContractPage?require('@/assets/img/logo-team-auth.svg'):require('@/assets/img/logo-auth.svg')" alt="">
                    </router-link>
                    <div class="mt40 text-center" v-else>
                        <img :src="isContractPage?require('@/assets/img/logo-team-auth.svg'):require('@/assets/img/logo-auth.svg')" alt="">
                    </div>

                    <section class="container mt40">
                        <div class="auth-form-container">
                            <auth :isTeam="isContractPage?true:false" v-if="!token && !isBanned && isValidPhone && !isNoSuccess && !isNoSuccessSection"></auth>


                            <div class="auth-form" v-else-if="isBanned && !isNoSuccess">
                                <div class="auth-form__error">
                                    <div class="text-center">
                                        <svg class="big-icon" >
                                            <use xlink:href="@/assets/img/big-icons-sprite.svg#many-auth"></use>
                                        </svg>
                                    </div>

                                    <div class="mt32 text-center">
                                        <div class="text-size-l text-bold text-color-red2">Слишком много попыток входа!</div>
                                        <div class="mt16 text-size-ms">
                                            Вы заблокированы на 12 часов. Если у вас что-то срочное,<br>
                                            напишите администратору на <a href="mailto:zems@zems.pro">zems@zems.pro</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="auth-form" v-else-if="!isNoSuccessSection && !isNoRemovePageAccess">
                                <div class="auth-form__error">
                                    <div class="text-center">
                                        <div>
                                            <svg class="big-icon">
                                                <use xlink:href="@/assets/img/big-icons-sprite.svg#cat"></use>
                                            </svg>
                                        </div>

                                        <div class="text-size-l text-bold text-color-red2 mt32">
                                            У номера {{(user.phone)?user.phone:formAuthFields.login ? formAuthFields.login.value : ''}} нет доступа к сайту
                                        </div>
                                        <div class="mt16 text-size-ms">
                                            Если он должен быть,<br>
                                            напишите администратору на <a href="mailto:zems@zems.pro">zems@zems.pro</a>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="auth-form" v-else>
                                <div class="auth-form__error">
                                    <div class="text-center">
                                        <div>
                                            <svg class="big-icon" >
                                                <use xlink:href="@/assets/img/big-icons-sprite.svg#cat"></use>
                                            </svg>
                                        </div>

                                        <div class="text-size-l text-bold text-color-red2 mt32">
                                            У номера {{(user.phone)?user.phone:''}} нет доступа<br>
                                            к этому разделу
                                        </div>
                                        <div class="mt16 text-size-ms">
                                            Если он должен быть,<br>
                                            напишите администратору на <a href="mailto:zems@zems.pro">zems@zems.pro</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
				<vue-footer v-if="!isNoSuccessSection" :class="{'footer--center': !(isModerator)}" :show-logo="isModerator" :hide-offer="true"></vue-footer>
            </section>

        </main>
        <popup :is-set-styled="false" :show="popups.sectionAdd.show" :name="popups.sectionAdd.name" :width="400" :add-class="'add-cat add-cat-uppercase'">
            <section-add></section-add>
        </popup>

        <popup :is-set-styled="false" :show="popups.sectionRemoveError.show" :name="popups.sectionRemoveError.name" :width="400" :is-btn-close="false" >
            <section-remove-error></section-remove-error>
        </popup>

        <popup :is-set-styled="false" :show="popups.sectionForbiddenError.show" :name="popups.sectionForbiddenError.name" :width="400" :is-btn-close="false">
            <forbidden-error></forbidden-error>
        </popup>

        <div class="something-went-wrong" v-if="popups.somethingWentWrong.show">
            <svg class="error-icon">
                <use xlink:href="@/assets/img/big-icons-sprite.svg#error"></use>
            </svg>
            <div class="text-size-m text-bold mt8">
                Что-то пошло не так.<br>
                Обновите страницу
            </div>
            <a href="." class="btn btn--ico mt16">
                Обновить страницу
            </a>
        </div>
    </div>
</template>
<script>
    import {mapState} from 'vuex';
    import TopSections from '@/components/moderator/Rules/TopSections.vue'
    import TopSectionsStaff from '@/components/moderator/Rules/TopSectionsStaff.vue'
    import Popup from '@/components/modal/Popup.vue'
    import Auth from '@/components/user/auth/AuthPersonal.vue'
    import Tooltip from '@/components/Tooltip.vue'
	import Tumbler from '@/components/Tumbler.vue';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue'
    import VueFooter from '@/components/VueFooter.vue'
    import HeaderLogo from '@/components/moderator/header/HeaderLogo.vue'
    import draggable from '@/helpers/vuedraggable.js'
    import RulesSearch from '@/components/moderator/RulesSearch.vue';
    import SectionAdd from '@/components/modal/rules/SectionAdd.vue';
    import SectionRemoveError from '@/components/modal/rules/SectionRemoveError.vue';
    import ForbiddenError from '@/components/modal/rules/ForbiddenError.vue';

    export default {
        components: {
            TopSections,
            Popup,
            Auth,
            Tooltip,
            SubmitBtn,
            VueFooter,
            HeaderLogo,
            draggable,
            RulesSearch,
            SectionAdd,
            SectionRemoveError,
            ForbiddenError,
			Tumbler,
            TopSectionsStaff
    },
        created() {
            this.$router.onReady(() => {
                this.$store.dispatch('users/getCurrent',{'routeName':this.$route.name}).then(()=>{
                    if(!this.user.is_rules && (this.user.is_can_contract || this.user.is_can_dismiss) && !this.isStaffPage && !(this.$route.name == 'users-scheme' && this.user.is_can_user_scheme)){
                        this.$router.push('/staff/')
                    }
                });
                this.$store.dispatch('options/getList');
                this.$store.dispatch('rules/getMarks');
            });
        },
        mounted() {
            let scrollWidth = window.innerWidth - document.documentElement.clientWidth;
            if (scrollWidth == '0') {
                document.getElementsByTagName('body')[0].classList.add("scroll-mac-os");
            }
        },
        data() {
            return {
                userTooltipActive: false,
                showBlockBtn: false,
            }
        },
        computed: {
			isNoRemovePageAccess(){
				return (this.isRemovedPage && !this.user.access_rights.is_owner)
			},
			isRemovedPage() {
	            return this.$route.name == 'rules-removed';
	        },
			isShowBottomHeader(){
				return !this.isUsersScheme && !this.isStaffPage && !this.isContactsPage && this.topSections.length > 3 ;
			},
            isContractPage(){
                return this.$route.name === 'user-contract'
            },
            isStaffPage() {
                return this.$route.name === 'moderator-staff' || this.$route.name === 'moderator-staff-detail' || this.$route.name === 'moderator-contract' || this.$route.name === 'moderator-contract-detail';
            },
			isUserContract(){
				return this.$route.name === 'user-contract';
			},
			isContactsPage(){
				return this.$route.name === 'moderator-contacts';
			},
            isSectionDetail() {
                return this.$route.name === 'rules-category-settings'
            },
			isUsersScheme() {
                return this.$route.name === 'users-scheme'
            },
            isScreencasts() {
                return this.$route.name === 'screencasts';
            },
            isModerator() {
                if (this.user.access_rights) {
                    return this.user.access_rights.is_moderator;
                }
                else {
                    return false;
                }
            },
            isContractor() {
                if (this.user.access_rights) {
                    return this.user.access_rights.is_contract;
                }
                else {
                    return false;
                }
            },
            token() {
                return this.localStorage.token !== 'false' && this.localStorage.token !== null && this.localStorage.token !== undefined ? this.localStorage.token : false
            },
            isEditing() {
              return this.popups.addRule.show;
            },
            ...mapState({
                isSearch: state => state.rules.isSearch,
                isSearchPrev: state => state.rules.isSearchPrev,
                searchStr: state => state.rules.searchStr,
                isLoadItems: state => state.rules.isLoadItems,
                deactivatedItems: state => state.rules.deactivatedItems,
                popups: state => state.popups.items,
                user: state => state.users.user,
                formAuthFields: state => state.auth.forms.auth.fields,
                isValidPhone: state => state.auth.isValidPhone,
                topSections: state => state.rules.topSections,
                isBanned: state => state.auth.isBanned,
                cookiesWarning: state => state.users.cookiesWarning,
                isUserLoad: state => state.users.isLoaded,
                isNoSuccess: state => state.auth.isNoSuccess,
                isNoSuccessSection: state => state.auth.isNoSuccessSection,
                item: state => state.rules.editItem,
                tumblers: state => state.rules.tumblers,
                previousSection: state => state.rules.previousSection,
				prevRoute: state => state.menus.prevRoute,
                userSectRightLoader: state => state.rulesStaff.userSectRightLoader,
                editorOpen: state => state.contracts.editorOpen,
            }),
            activeTopSection(){
              if(this.isSearch || !this.topSections.length) return false;
              return this.$route.params.id ? this.$route.params.id : this.topSections[0].id;
            },
            curTopSection (){
              if(!this.topSections[0]) return false;

              for (let i in this.topSections) {
                if(this.topSections[i].id == this.activeTopSection){
                  return this.topSections[i];
                }
              }
            },
        },
        methods: {
			closeFullscreenViewer(){
				document.getElementById('closeFullscreenViewer').click();
			},
			closeSectionDetail(){
				if(this.prevRoute){
					this.$router.push(this.prevRoute);
				}else{
					this.$router.push('/');
				}
			},
            resetSearch: function (e) {
                this.$store.commit('rules/setIsSearch',false);
            },
            setIsNoSuccessSection: function (e) {
                this.$store.commit('auth/setIsNoSuccessSection',false)
            },
            logout() {
                this.$store.dispatch('auth/logout');
                this.$store.commit('auth/setStep', {step: 1})

            },
            closeAddRule: function () {
                this.$store.commit('rules/setSelectedSection', true);
                if(this.isSearchPrev){
                    this.$store.commit('rules/setIsSearch', true);
                    this.$store.commit('rules/setIsSearchPrev', false);
                    this.$store.dispatch('rules/getItems', {search: this.searchStr, reload: true});
                    if (this.$router.history.current.fullPath !== '/') {
                        this.$router.push({path: '/'});
                    }
                } else {
                    if(this.item.id && !this.item.active){
                        this.$router.push('/removed/');
                    } else if(this.item.id && this.item.active){
                        if(this.$route.path != '/sid'+this.item.sectionTop+'/sub'+this.item.section+'/'){
                            this.$router.push('/sid'+this.item.sectionTop+'/sub'+this.item.section+'/');
                        }

                    } else if(this.previousSection.top.id && this.previousSection.second.id){
                        if(this.$route.path != '/sid'+this.previousSection.top.id+'/sub'+this.previousSection.second.id+'/'){
                            this.$router.push('/sid'+this.previousSection.top.id+'/sub'+this.previousSection.second.id+'/');
                        }
                    }
                }

                this.$store.commit('popups/close', {name: this.popups.addRule.name});
                this.$store.commit('rules/setUseShortcut', false);
            },


        }
    }
</script>
<style lang="sass">
    body
</style>
